// extracted by mini-css-extract-plugin
export default {"close":"ViewerCloseButton_close__MM5pt"};